import React, { useState } from "react";
import { LABEL_TEXT, IMAGE_THUMBNAIL } from "../styles/classNames";

/**
 * Компонент для загрузки и отображения фотографий
 * Поддерживает как существующие фото (S3 URLs), так и новые (Base64)
 */
export function PhotoUpload({ photos = [], onUpload, onRemove, maxPhotos = 3 }) {
  const currentCount = photos.length;
  const canUpload = currentCount < maxPhotos;
  const [fullscreenPhoto, setFullscreenPhoto] = useState(null);

  /**
   * Проверка, является ли URL внешним (S3) или Base64
   */
  const isExternalUrl = (url) => {
    return url.startsWith('http://') || url.startsWith('https://');
  };

  return (
    <div className="block">
      <div className={LABEL_TEXT}>Фото (селфи/визитка) - до {maxPhotos} шт</div>
      <input 
        id="photo-upload-input"
        type="file" 
        accept="image/*" 
        multiple 
        onChange={onUpload} 
        className="hidden" 
        disabled={!canUpload}
      />
      <label 
        htmlFor="photo-upload-input"
        className={`inline-block px-4 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${
          !canUpload ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {canUpload ? 'Выбрать файлы' : `Максимум ${maxPhotos} фото`}
      </label>
      
      {currentCount > 0 && (
        <div className="mt-2 grid grid-cols-3 gap-2">
          {photos.map((url, index) => {
            const isS3Photo = isExternalUrl(url);
            
            return (
              <div key={index} className="relative group">
                <img 
                  src={url} 
                  alt={`Фото ${index + 1}`} 
                  className={`${IMAGE_THUMBNAIL} cursor-pointer hover:opacity-80 transition-opacity`}
                  loading="lazy"
                  onClick={() => setFullscreenPhoto(url)}
                />
                {/* Индикатор типа фото */}
                {isS3Photo && (
                  <div className="absolute bottom-1 left-1 bg-blue-500 dark:bg-blue-600 text-white text-[10px] px-1 rounded">
                    S3
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => onRemove(index)}
                  className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700 text-white rounded-full w-6 h-6 text-xs shadow-lg"
                  title="Удалить фото"
                >
                  ✕
                </button>
              </div>
            );
          })}
        </div>
      )}
      
      <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        Загружено: {currentCount} / {maxPhotos}
      </div>

      {/* Fullscreen photo modal */}
      {fullscreenPhoto && (
        <div 
          className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
          onClick={() => setFullscreenPhoto(null)}
        >
          <button 
            className="absolute top-4 right-4 text-white text-4xl font-bold hover:opacity-70 transition-opacity"
            onClick={() => setFullscreenPhoto(null)}
            title="Закрыть"
          >
            ✕
          </button>
          <img 
            src={fullscreenPhoto} 
            alt="Fullscreen view" 
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
